export default __webpack_public_path__ + "static/media/selectcard.b070217c.mp3";